export default {
  date: "Termin",
  module: "Modul",
  moduleDate: "Modultermin",
  moduleDateUpdate: "Modultermin ändern",
};
